export const BASE_TITLE = 'Marketplace | NexRep ';

export const SOCRATESAPIURL = process.env.REACT_APP_SOCRATESAPI;

export const MUILICENCEKEY = process.env.REACT_APP_MUI_LICENCE_KEY;

